/* eslint eqeqeq: 0 */
import { Field, Formik } from "formik";
import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { AddAdminNewUser, getUserType } from "../../../../constants/apiParams";
import apiCall, { METHOD } from "../../../../constants/baseUrl";
import { getUserID } from "../../../../util/utils";
import { AdminAddUserSchema } from "../../../../util/validationSchema";
import ErrorMessageFormik from "../../../CommanComponents/ErrorMessageFormik";
import Footer from "../../../Footer/FooterMobile";
import LoadingPage from "../../../CommanComponents/LoadingPage";
import UserTypeList from "./UserTypeList";

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_type_name: "",
      user_type_id: 0,
      user_type_list: [],
      reportDialogueStatus: false,
      is_active: false,
      addUserLoader: false,
      manage_user_type_id: [],
      manage_user_type_name: [],
    };
  }

  componentDidMount() {
    apiCall(
      METHOD.QUERY,
      getUserType(),
      (data) => {
        let brandNameDefault,
          brandID,
          manage_user_type_id = [],
          manage_user_type_name = [];

        let userGroupList = data.user_group_list;
        userGroupList.forEach((user) => {
          user.isChecked = false;
        });

        if (userGroupList && userGroupList.langth !== 0) {
          brandNameDefault = userGroupList[0].name;
          brandID = userGroupList[0].id;
          manage_user_type_id.push(userGroupList[0].id);
          manage_user_type_name.push(userGroupList[0].name);
          userGroupList[0].isChecked = true;
        }

        this.setState({
          user_type_list: userGroupList,
          user_type_id: brandID,
          user_type_name: brandNameDefault,
          manage_user_type_id,
          manage_user_type_name,
        });
      },
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  }

  handleLoader = (status) => {
    this.setState({
      isLoading: status,
    });
  };

  handleReportDialogue = () => {
    this.setState((prevState) => {
      return {
        reportDialogueStatus: !prevState.reportDialogueStatus,
      };
    });
  };

  handleSubmit = (value) => {
    if (this.state.manage_user_type_id.length == 0) {
      toast.info(this.props.t("AdminAddUser.user_group_validation"));
    } else {
      this.createNewUser(value);
    }
  };

  createNewUser = (value) => {
    const { user_type_id, is_active } = this.state;
    const { name, first_name, email, password } = value;
    let active_value = 0;
    if (is_active) {
      active_value = 1;
    } else {
      active_value = 0;
    }
    apiCall(
      METHOD.QUERY,
      AddAdminNewUser(
        getUserID(),
        active_value,
        name,
        first_name,
        email,
        password,
        user_type_id
      ),
      (data) => {
        toast.success(this.props.t(data.message));
        this.props.handleAddModal(true);
      },
      (isLoading) => {
        this.setState({ addUserLoader: isLoading });
      },
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  checkboxChangeEvent = (e, id, name) => {
    let userGroupData = this.state.user_type_list;
    const index = userGroupData.findIndex((user) => user.id == id);
    const value = e.target.checked;
    let manage_user_type_id = this.state.manage_user_type_id;
    let manage_user_type_name = this.state.manage_user_type_name;
    if (value) {
      manage_user_type_id.push(id);
      manage_user_type_name.push(name);
      if (index != -1) {
        userGroupData[index].isChecked = true;
      }
    } else {
      manage_user_type_id = manage_user_type_id.filter((u_id) => u_id != id);
      manage_user_type_name = manage_user_type_name.filter(
        (u_name) => u_name != name
      );
      if (index != -1) {
        userGroupData[index].isChecked = false;
      }
    }

    let user_type_id = manage_user_type_id.join(",");
    let user_type_name = manage_user_type_name.join(", ");

    this.setState(
      {
        manage_user_type_id,
        manage_user_type_name,
        user_type_name,
        user_type_id,
        user_type_list: userGroupData,
      },
      () => {
        console.log("user_type_list", this.state.user_type_list);
      }
    );
  };
  render() {
    const {
      isLoading,
      user_type_name,
      addUserLoader,
      is_active,
      manage_user_type_id,
    } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <Formik
              enableReinitialize
              initialValues={{
                name: "",
                first_name: "",
                email: "",
                password: "",
                is_active: false,
              }}
              validationSchema={AdminAddUserSchema(
                t("AdminAddUser.name_error"),
                t("AdminAddUser.first_name_error"),
                t("AdminAddUser.email_error"),
                t("AdminAddUser.email_valid_error"),
                t("AdminAddUser.passwordValidation"),
                t("AdminAddUser.toShortValidation"),
                t("AdminAddUser.toLongValidation")
              )}
              onSubmit={(values, actions) => {
                this.handleSubmit(values);
              }}
            >
              {({ handleSubmit }) => (
                <div className="d-block">
                  <div
                    className="modal fade show"
                    id="NewEvent"
                    tabindex="-1"
                    aria-labelledby="NewEventLabel"
                    aria-modal="true"
                    style={{ display: "block" }}
                  >
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                      <div className="modal-content">
                        <div className="modal-header border-0 d-block pt-4 pb-0">
                          <div className="d-flex align-items-center justify-content-between mb-4">
                            <button
                              type="button"
                              onClick={() => this.props.handleAddModal(false)}
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <i className="zmdi zmdi-close zmdi-hc-2x"></i>
                            </button>

                            {addUserLoader ? (
                              <div className="btn btn-primary-theme pointer">
                                {t("AdminAddUser.save")}
                                <div className="spinner-border spinner-border-sm ml-1 text-blue">
                                  <span className="sr-only">
                                    {t("GeneralMessages.loading")}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="btn btn-primary-theme pointer"
                                onClick={handleSubmit}
                              >
                                {t("AdminAddUser.save")}
                              </div>
                            )}
                          </div>
                          <h5 className="modal-title">
                            {t("AdminAddUser.title")}
                          </h5>
                        </div>
                        <div className="modal-body">
                          <div className="middle-section sab-middle-section1">
                            {isLoading && <LoadingPage />}
                            <div className="container my-4 z-index-99">
                              <div className="form-group mb-5">
                              <div className="form-group m-auto text-center">
                          <a
                            href="javascript;:"
                            className="clearfix text-dark"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleReportDialogue();
                            }}
                          >
                            <label className="font-14 d-block">
                              {t("AdminAddUser.group")}
                            </label>
                            <div className="icon-drop-bg d-inline-block mt-3 pointer">
                              <div className="rounded-circle">
                                <strong>
                                  <h2>
                                    {manage_user_type_id &&
                                      manage_user_type_id.length}
                                  </h2>
                                </strong>
                              </div>
                              <span className="font-12 word-break">
                                {user_type_name && user_type_name}
                              </span>
                            </div>
                          </a>
                        </div>

                                <div className="form-group">
                                  <div className="container my-4 00z-index-99">
                                    <form>
                                      <div className="form-group">
                                        <label className="font-14">
                                          {t("AdminAddUser.name_lable")}
                                        </label>
                                        <Field
                                          type="text"
                                          name="name"
                                          placeholder={t(
                                            "AdminAddUser.name_placeholder"
                                          )}
                                          className="form-control"
                                          required
                                        />
                                        <ErrorMessageFormik name="name" />
                                      </div>

                                      <div className="form-group">
                                        <label className="font-14">
                                          {t("AdminAddUser.first_name_lable")}
                                        </label>
                                        <Field
                                          type="text"
                                          name="first_name"
                                          placeholder={t(
                                            "AdminAddUser.first_name_placeholder"
                                          )}
                                          className="form-control"
                                          required
                                        />
                                        <ErrorMessageFormik name="first_name" />
                                      </div>

                                      <div className="form-group">
                                        <label className="font-14">
                                          {t("AdminAddUser.email_lable")}
                                        </label>
                                        <Field
                                          type="text"
                                          name="email"
                                          placeholder={t(
                                            "AdminAddUser.email_placeholder"
                                          )}
                                          className="form-control"
                                          required
                                        />
                                        <ErrorMessageFormik name="email" />
                                      </div>

                                      <div className="form-group">
                                        <label className="font-14">
                                          {t("AdminAddUser.password_lable")}
                                        </label>
                                        <Field
                                          type="password"
                                          name="password"
                                          placeholder="************"
                                          className="form-control"
                                          required
                                        />
                                        <ErrorMessageFormik name="password" />
                                      </div>

                                      <div className="form-group">
                                        <label
                                          htmlFor="is_active"
                                          className="mr-4"
                                        >
                                          {t("AdminAddUser.is_active_lable")}
                                        </label>
                                        <input
                                          type="checkbox"
                                          className="ml-2"
                                          checked={is_active}
                                          onChange={(e) =>
                                            this.setState({
                                              is_active: e.target.checked,
                                            })
                                          }
                                        />
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.reportDialogueStatus && (
                          <UserTypeList
                            closeBrandDialogue={this.handleReportDialogue}
                            status={this.state.reportDialogueStatus}
                            BrandList={this.state.user_type_list}
                            checklist={this.state.manage_user_type_id}
                            checkboxChangeEvent={this.checkboxChangeEvent}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show"></div>
                </div>
              )}
            </Formik>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(AddUser));
